import { BACKEND_URL, fetchWithAuthRetry } from "./client";

export const fetchProducts = async () =>
  fetchWithAuthRetry(`${BACKEND_URL}items/`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const fetchProductDetail = async (productId) =>
  fetchWithAuthRetry(`${BACKEND_URL}item-detail?id=${productId}`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const fetchColors = async () =>
  fetchWithAuthRetry(`${BACKEND_URL}colors`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const fetchCategories = async () =>
  fetchWithAuthRetry(`${BACKEND_URL}categories`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
